import React from 'react'

import { useTranslation } from 'language/translator'

/* Atoms */
import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import ListItemIcon from 'components_new/atoms/List/ListItemIcon'
import MenuItem from 'components_new/atoms/Menu/MenuItem'

/* Molecules */
import FilterPopover from 'components_new/molecules/FilterPopover'

import { PeriodSelectorProps } from '.'
import { getPeriodFilterDisplayValue, usePeriodFilterOptions } from '../utils'


const Mobile = (props: PeriodSelectorProps) => {
  const { showActive, size } = props

  const { t } = useTranslation()

  // @TODO
  const handleClose = () => {}

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden'
      }}
    >
      <FilterPopover
        active={!!props.periodFilter}
        iconName="CalendarMonthOutlined"
        primary={t('date_filters', 'time_period')}
        secondary={getPeriodFilterDisplayValue(props.periodFilter, t)}
        showActive={showActive}
        size={size}
        tooltipTitle={t('date_filters', 'time_period')}
        tooltipValue={getPeriodFilterDisplayValue(props.periodFilter, t)}
      >
        <Box sx={{ py: 1 }}>
          {props.allowReset !== false && (
            <MenuItem
              selected={!props.periodFilter}
              onClick={() => {
                props.onSubmit(null)
                handleClose()
              }}
            >
              <ListItemIcon>
                <Icon name="EventRepeatOutlined" />
              </ListItemIcon>
              {t('global', 'reset')}
            </MenuItem>
          )}
          {usePeriodFilterOptions().map((option, i) => (
            <MenuItem
              key={i}
              selected={props.periodFilter === option.value}
              onClick={() => {
                props.onSubmit(option.value)
                handleClose()
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Box>
      </FilterPopover>
    </Box>
  )
}

export default Mobile
